<template>
  <a-page-heading>アカウント情報確認・変更</a-page-heading>
  <m-section>
    <m-action-card
      title="マイク・スピーカー設定"
      icon="user-setting"
      :header-border="true"
      :narrow-body="true"
      :help="true"
      @help:click="helpModalVisible = true"
    >
      <form ref="form" class="t-profile-edit-user-info__form" @submit.prevent="handleFormSubmit">
        <div class="t-profile-edit-password__fields">
          <m-form-input label="マイク">
            <a-select-field
              id="microphoneEditSelectField"
              v-model="currentMicrophone"
              :options="microphoneListOptions"
              placeholder="選択してください"
            />
          </m-form-input>
          <m-form-input label="スピーカー">
            <a-select-field
              id="speakerEditSelectField"
              v-model="currentSpeaker"
              :options="speakerListOptions"
              placeholder="選択してください"
            />
          </m-form-input>
        </div>
        <m-form-action-buttons class="t-profile-edit-user-info__buttons">
          <a-button
            id="MicrophoneAndSpeakerSaveButton"
            variant="block"
            color="primary"
            @click="handleMicrophoneAndSpeakerEdit(currentMicrophone, currentSpeaker)"
            >保存</a-button
          >
          <a-button
            id="MicrophoneAndSpeakerSaveCancelButton"
            variant="outlined"
            color="primary"
            @click="handleCancelClick"
            >キャンセル</a-button
          >
        </m-form-action-buttons>
      </form>
    </m-action-card>
  </m-section>
  <teleport to="body">
    <o-modal
      id="profileEdit_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="460px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="MicrophoneAndSpeakerModalCloseButton"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleCloseModal"
        />
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      id="profileEdit_helpModal"
      v-model:visible="helpModalVisible"
      class="o-modal-audio-setting-hint"
      footer-variant="confirmation"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <template #title>マイク・スピーカーの既定/通信とは</template>
      <a-text v-html="currentAudioHintMessage"> </a-text>
    </o-modal>
  </teleport>
</template>

<script>
import { messageContent } from '@/common/messageContent.js';
import { DEFAULT_DEVICE } from '@/libs/constants';
import { customRequest } from '@/common/customRequest.js';

export default {
  name: 'o-calling-modal',
  components: {},
  mixins: [messageContent, customRequest],
  props: {
    speakerDevices: {
      type: Array,
      default: new Array(0),
    },
    inputDevices: {
      type: Array,
      default: new Array(0),
    },
  },
  emits: ['update:update-speaker', 'update:update-microphone'],
  data() {
    return {
      //Twilio Device
      currentMicrophone: '',
      currentSpeaker: '',
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      microphoneListOptions: [{ label: '選択してください', value: localStorage.getItem('microphoneId') }],
      speakerListOptions: [{ label: '選択してください', value: localStorage.getItem('speakerId') }],
      helpModalVisible: false,
      COTOHACallCenterManualURL: '',
    };
  },
  computed: {
    currentAudioHintMessage() {
      return messageContent.audioHintMessage(this.COTOHACallCenterManualURL);
    },
  },
  watch: {
    inputDevices(val) {
      this.loadMicrophoneList(val);
    },
    speakerDevices(val) {
      this.loadSpeakerList(val);
    },
  },
  async created() {
    this.loadMicrophoneList(this.inputDevices);
    this.loadSpeakerList(this.speakerDevices);
    await this.handlerFetchSettingOther();
    // Ask browser for audio permission
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(stream => {
        if (this.microphoneListOptions.length === 1 && !this.microphoneListOptions[0]['value']) {
          this.microphoneListOptions = [
            { label: '選択してください', value: localStorage.getItem('microphoneId') || DEFAULT_DEVICE },
          ];
        }
        if (this.speakerListOptions.length === 1 && !this.speakerListOptions[0]['value']) {
          this.speakerListOptions = [
            { label: '選択してください', value: localStorage.getItem('speakerId') || DEFAULT_DEVICE },
          ];
        }
        stream.getTracks()[0].stop();
      })
      .catch(err => {
        console.log(err);
        this.showInfoModal(messageContent.chromeMicroPermissionError);
      });
  },
  async mounted() {},
  methods: {
    loadMicrophoneList(devices) {
      console.info('loadMicrophoneList');
      if (!devices.length) return;
      const currentMicrophoneLocal = localStorage.getItem('microphoneId');
      this.microphoneListOptions = devices;
      for (const device of this.microphoneListOptions) {
        device.label = device.label.replace(/\(....:....\)/, '');
        if (device.value === currentMicrophoneLocal) this.currentMicrophone = currentMicrophoneLocal;
      }
    },
    loadSpeakerList(devices) {
      console.info('loadSpeakerList');
      if (!devices.length) return;
      console.info('loadSpeakerList start: ');
      const currentSpeakerLocal = localStorage.getItem('speakerId');
      console.info('localStorage speakerId: ', currentSpeakerLocal);
      this.speakerListOptions = devices;
      for (const device of this.speakerListOptions) {
        device.label = device.label.replace(/\(....:....\)/, '');
        if (device.value === currentSpeakerLocal) this.currentSpeaker = currentSpeakerLocal;
      }
      console.info('current speakerId: ', this.currentSpeaker);
    },
    handleCancelClick() {
      this.$router.push('/profilelist');
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    handleMicrophoneAndSpeakerEdit: function (microphoneId, speakerId) {
      console.info(`handleMicrophoneAndSpeakerEdit start: `);
      console.info(`after change microphoneId:${microphoneId}, speakerId: ${speakerId}`);
      if (!microphoneId) {
        this.showErrorModal(this.notSetItem('マイク'));
        return;
      }
      if (!speakerId) {
        this.showErrorModal(this.notSetItem('スピーカー'));
        return;
      }
      this.$emit('update:update-speaker', speakerId);
      this.$emit('update:update-microphone', microphoneId);
      console.info(`handleMicrophoneAndSpeakerEdit end`);
      this.$router.push('/profilelist');
    },
    handlerFetchSettingOther: async function () {
      const self = this;
      await this.postRequest('/settingother')
        .then(data => {
          if (data.status === 'success') {
            if (data.data) {
              self.COTOHACallCenterManualURL = data.data.COTOHACallCenterManualURL
                ? data.data.COTOHACallCenterManualURL
                : '';
            }
          } else {
            self.showErrorModal(messageContent.requireTry('設定の取得'));
          }
        })
        .catch(error => {
          self.showErrorModal(messageContent.requireTry('設定の取得'));
        });
    },
  },
};
</script>
